
import { styled } from '@mui/material/styles';
import { Box, Chip, Paper, Typography } from '@mui/material';

export const StatsCard = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(3),
  border: '1px solid #EDEDED',
  borderRadius: '12px',
  boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.02)',
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
}));

export const IconContainer = styled(Box)(({ theme }) => ({
  width: '48px',
  height: '48px',
  borderRadius: '10px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  marginRight: theme.spacing(2),
  flexShrink: 0,
}));

export const CardTitle = styled(Typography)(({ theme }) => ({
  fontWeight: 500,
  fontSize: '0.95rem',
  color: '#666666',
  marginBottom: theme.spacing(0.5),
  lineHeight: 1.4,
}));

export const MetricValue = styled(Typography)(({ theme }) => ({
  fontWeight: 700,
  fontSize: '2rem',
  color: '#1a1a1a',
  marginTop: theme.spacing(1),
  marginBottom: theme.spacing(1),
}));

export const TrendText = styled(Typography)(({ theme }) => ({
  fontWeight: 600,
  fontSize: '0.875rem',
  color: theme.palette.success.main,
  display: 'flex',
  alignItems: 'center',
  gap: '4px',
}));

export const SubInfoText = styled(Typography)(({ theme }) => ({
  fontSize: '0.875rem',
  color: '#888888',
}));

export const SuccessChip = styled(Chip)(({ theme }) => ({
  borderRadius: '4px',
  backgroundColor: theme.palette.success.light,
  color: theme.palette.white.main,
  fontWeight: 600,
  fontSize: '0.75rem',
  border: 'none',
  height: '22px',
}));

export const UnfilledChip = styled(Chip)(({ theme }) => ({
  borderRadius: '4px',
  backgroundColor: "#FFEBEE",
  color: "#D32F2F",
  fontWeight: 600,
  fontSize: '0.75rem',
  border: 'none',
  height: '22px',
}));

export const GreySpan = styled('span')(({ theme }) => ({
  color: theme.palette.grey[600],
}));
